/**
 * Json取得Repository
 */
import axios from "axios";
import logger from "../lib/logger";

const baseDomain = location.origin;
const baseURL = `${baseDomain}/kawabou/file/files`;

const http = axios.create({
  baseURL,
});

http.interceptors.request.use((request) => {
  if (process.env.NODE_ENV === "development") {
    logger.debug(
      "[JsonRepository]request url:" + request.baseURL + "/" + request.url
    );
  }
  return request;
});

http.interceptors.response.use(
  (response) => {
    return Promise.resolve({
      data: response.data,
      status: response.status,
    });
  },
  (error) => {
    logger.error("[JsonRepository]response faild");
    return Promise.resolve({
      error: error.response,
    });
  }
);
export default http;
